import { useState } from "react";
import { useToast } from "@chakra-ui/react";

export function useRecalculation({ 
  getRunId,        
  getStoreId,      
  onSuccess,       
}) {
  const [isRecalculating, setIsRecalculating] = useState(false);
  const toast = useToast();

  const handleRecalculation = async () => {
    const runId   = getRunId();
    const storeId = getStoreId();

    if (!runId || !storeId) {
      toast({
        title: "Missing Data",
        description: "Missing runId or storeId.",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
      return;
    }

    try {
      setIsRecalculating(true);
      const query    = new URLSearchParams({ runId, storeId }).toString();
      const response = await fetch(
        `https://orgi-api.sconexsoft.com/aicalc/calculate-score?${query}`
      );
      if (!response.ok) throw new Error("API failed");
      await response.text();

      toast({
        title: "Success",
        description: "Stores Calculated Successfully",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });

      if (onSuccess) await onSuccess();
    } catch (error) {
      console.error(error);
      toast({
        title: "Error",
        description: "Recalculation failed",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    } finally {
      setIsRecalculating(false);
    }
  };

  return { handleRecalculation, isRecalculating };
}